export const API_CONFIG={
  STRIPE_PRODUCT_ID: 'prod_SiVKIUfacn7gFR'
}

export const SEARCH_FOOTPRINTS=[
  'niche collaboration',
  'leave a reply',
  'write for us',
  'forum',
  'resources'
]

export const BACKLINK_CATEGORIES={
  'niche collaboration': 'Niche Collaborations',
  'leave a reply': 'Blog Comments',
  'write for us': 'Guest Posts',
  'forum': 'Forum Comments',
  'resources': 'Resource Pages'
}
